module.exports = "/images/Homepage-Integrations_Features.jpg";